var _circle, _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArtistHub = function SvgArtistHub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#artist-hub_svg__clip1_435_55)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "artist-hub_svg__a",
    width: 56,
    height: 56,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#artist-hub_svg__a)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#artist-hub_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AB4AE7",
    fillOpacity: 0.2,
    d: "M0 0h56v56H0z",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AB4AE7",
    d: "m43.638 14.656-4.329-2.499c-1.74-1.004-4.44-.695-9.264-.144l-7.75.886c-5.48.627-8.22.94-9.923 2.898-1.702 1.957-1.702 4.795-1.702 10.47v4.012c0 5.674 0 8.511 1.702 10.08.204.187.423.348.66.485l4.328 2.499a3.696 3.696 0 0 1-.658-.485C15 41.29 15 38.453 15 32.779v-4.012c0-5.674 0-8.512 1.702-10.47 1.703-1.957 4.443-2.27 9.923-2.896l7.75-.887c4.162-.476 6.744-.77 8.49-.198l1.433.827a3.699 3.699 0 0 0-.66-.486Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.4,
    d: "m43.638 14.656-4.329-2.499c-1.74-1.004-4.44-.695-9.264-.144l-7.75.886c-5.48.627-8.22.94-9.923 2.898-1.702 1.957-1.702 4.795-1.702 10.47v4.012c0 5.674 0 8.511 1.702 10.08.204.187.423.348.66.485l4.328 2.499a3.696 3.696 0 0 1-.658-.485C15 41.29 15 38.453 15 32.779v-4.012c0-5.674 0-8.512 1.702-10.47 1.703-1.957 4.443-2.27 9.923-2.896l7.75-.887c4.162-.476 6.744-.77 8.49-.198l1.433.827a3.699 3.699 0 0 0-.66-.486Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B151C9",
    d: "M15 28.766c0-5.674 0-8.512 1.702-10.47 1.703-1.957 4.443-2.27 9.923-2.896l7.75-.887c5.48-.626 8.22-.94 9.923.629C46 16.71 46 19.547 46 25.221v4.012c0 5.674 0 8.511-1.702 10.47-1.703 1.957-4.443 2.27-9.923 2.896l-7.75.887c-5.48.626-8.22.94-9.923-.629C15 41.29 15 38.453 15 32.779v-4.012Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.39 28.012c0 1.38-1.112 2.624-2.485 2.776-1.372.153-2.485-.843-2.485-2.224 0-1.38 1.113-2.623 2.485-2.776 1.373-.152 2.485.843 2.485 2.224ZM27.47 23.448c0 1.38-1.113 2.623-2.485 2.776-1.373.152-2.485-.843-2.485-2.224 0-1.38 1.112-2.624 2.485-2.776 1.372-.153 2.484.843 2.484 2.224ZM27.47 35.448c0 1.38-1.113 2.623-2.485 2.776-1.373.152-2.485-.843-2.485-2.224 0-1.38 1.112-2.624 2.485-2.776 1.372-.153 2.484.843 2.484 2.224Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m25.318 22.781 12.92 4.564a1 1 0 0 1 .166 1.81l-12.92 7.436-.998-1.734 11.035-6.35-10.87-3.84.667-1.886Z",
    clipRule: "evenodd",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#artist-hub_svg__c)",
    d: "M0 0h56v56H0z",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "artist-hub_svg__c",
    x1: 0,
    x2: 56,
    y1: 0,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "artist-hub_svg__b",
    width: 64,
    height: 64,
    x: -4,
    y: -2,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 1,
    result: "effect1_dropShadow_435_55"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_435_55"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.372549 0 0 0 0 0.101961 0 0 0 0 0.666667 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_435_55",
    result: "effect2_dropShadow_435_55"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_435_55",
    result: "shape"
  })))));
};
export default SvgArtistHub;